import { createAsyncThunk } from "@reduxjs/toolkit";
import { baseUrlApi } from "../../proxy";
import axios, { AxiosResponse } from "axios";

export const toGetOffers = createAsyncThunk<AxiosResponse<any, any>, any>(
  "offers/toGetOffers",
  async (lang) => {
    try {
      const response = await axios.get(
        `${baseUrlApi}portal/offers?lang=${lang}`
      );
      return response;
    } catch (error) {
      throw error;
    }
  }
);
